
import React from 'react';
import { cn } from '@/lib/utils';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface MobileMenuToggleProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const MobileMenuToggle: React.FC<MobileMenuToggleProps> = ({ isOpen, onClick, className }) => {
  return (
    <button 
      onClick={onClick}
      className={cn(
        "w-10 h-10 rounded-full flex items-center justify-center neo-glass",
        "hover:bg-background/80 transition-all", 
        className
      )}
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      <AnimatePresence mode="wait" initial={false}>
        {isOpen ? (
          <motion.div
            key="close"
            initial={{ rotate: -90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: 90, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <X size={18} />
          </motion.div>
        ) : (
          <motion.div
            key="menu"
            initial={{ rotate: 90, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            exit={{ rotate: -90, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Menu size={18} />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
};

export default MobileMenuToggle;
